var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import React, { useEffect, useRef, useState } from "react";
import { phoneParser } from "@riseart/fe-utils";
import { FormInput } from "../Input";
import { FormSelect, FormSelectOption } from "../Select";
import { formPhoneWrapperCls, formPhoneCls, formPhoneCodesCls } from "./Input.less";
import { raFormSelectCls, raFormSelectDropdownCls } from "../../form/Form.less";
function FormInputPhone(props) {
  var inputRef = useRef();
  var DIALING_CODES = props.dialingCodes, initialCountryCode = props.initialCountryCode, customData = props.customData, onChange = props.onChange;
  var customCountryCode = customData && customData.countryCode;
  var inputCodes = {
    initial: initialCountryCode && initialCountryCode.toLowerCase(),
    custom: customCountryCode && customCountryCode.toLowerCase()
  };
  var defaultDialingCode = inputCodes.initial && DIALING_CODES ? DIALING_CODES.filter(function(_ref) {
    var code = _ref.code;
    return code === inputCodes.initial;
  })[0] : "";
  var customDialingCode = inputCodes.custom && DIALING_CODES ? DIALING_CODES.filter(function(_ref2) {
    var code = _ref2.code;
    return code === inputCodes.custom;
  })[0] : "";
  var parsedPhone = DIALING_CODES && props.initialValue ? phoneParser(DIALING_CODES, props.initialValue, inputCodes.custom || null) : null;
  var _useState = useState({
    countryCode: parsedPhone && parsedPhone.countryCode || customDialingCode && customDialingCode.code || defaultDialingCode && defaultDialingCode.code || "",
    dialingCode: parsedPhone && parsedPhone.dialingCode || customDialingCode && customDialingCode.dialingCode || defaultDialingCode && defaultDialingCode.dialingCode || "",
    phone: parsedPhone && parsedPhone.phone || props.initialValue || ""
  }), _useState2 = _slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
  useEffect(function() {
    if (typeof onChange === "function") {
      onChange(value.phone ? "+".concat(value.dialingCode, " ").concat(value.phone) : null, value);
    }
  }, [value]);
  return /* @__PURE__ */ React.createElement("div", {
    className: formPhoneWrapperCls
  }, DIALING_CODES ? /* @__PURE__ */ React.createElement("span", {
    className: formPhoneCodesCls
  }, /* @__PURE__ */ React.createElement(FormSelect, {
    defaultValue: value.countryCode,
    onChange: /* @__PURE__ */ __name(function onChange2(countryCode) {
      setValue(function(prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          countryCode,
          dialingCode: (DIALING_CODES.filter(function(_ref3) {
            var code = _ref3.code;
            return code === countryCode;
          })[0] || {}).dialingCode || ""
        });
      });
      if (inputRef.current) {
        inputRef.current.focus({
          cursor: "end"
        });
      }
    }, "onChange"),
    choiceTransitionName: null,
    transitionName: null,
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    }, "getPopupContainer"),
    className: raFormSelectCls,
    popupClassName: raFormSelectDropdownCls,
    variant: "borderless"
  }, DIALING_CODES.map(function(_ref4) {
    var code = _ref4.code, dialingCode = _ref4.dialingCode;
    var countryCode = code && code.toLowerCase();
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: countryCode,
      value: countryCode
    }, /* @__PURE__ */ React.createElement("img", {
      loading: "lazy",
      width: "20",
      src: "https://flagcdn.com/w20/".concat(countryCode, ".png"),
      srcSet: "https://flagcdn.com/w40/".concat(countryCode, ".png 2x"),
      alt: dialingCode
    }), "\xA0 +", dialingCode);
  }))) : null, /* @__PURE__ */ React.createElement(FormInput, {
    ref: inputRef,
    defaultValue: value.phone,
    className: formPhoneCls,
    onChange: /* @__PURE__ */ __name(function onChange2(e) {
      return setValue(function(prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          phone: e.target.value
        });
      });
    }, "onChange"),
    prefix: /* @__PURE__ */ React.createElement("span", null),
    variant: "borderless"
  }));
}
__name(FormInputPhone, "FormInputPhone");
export {
  FormInputPhone
};
